import { render, staticRenderFns } from "./ControlProjectsList.vue?vue&type=template&id=56d75cd6&"
import script from "./ControlProjectsList.vue?vue&type=script&lang=js&"
export * from "./ControlProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports